export const imports = {
  'docs/introduction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-introduction" */ 'docs/introduction.mdx'
    ),
  'docs/recipes.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-recipes" */ 'docs/recipes.mdx'
    ),
  'src/Currency/Currency.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-currency-currency" */ 'src/Currency/Currency.mdx'
    ),
  'src/Number/Number.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-number-number" */ 'src/Number/Number.mdx'
    ),
}
